/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled from 'styled-components';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledFlexContainer = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledFlexContainer/index.js